import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
export var allowedBadgeSymbols = {
  Button: Symbol('Button'),
  ButtonLink: Symbol('ButtonLink'),
  Tooltip: Symbol('Tooltip')
};
export function checkIsBadgeAllowed(child) {
  return child instanceof Object && 'type' in child && !!Object.getOwnPropertySymbols(child.type).find(function (symbol) {
    return Object.values(allowedBadgeSymbols).includes(symbol);
  });
}